import axios from 'axios';

const state = {
  meetingModal: false,
  visitorModal: false,
  meetingModalType: 'create',
  meetingDisplay: {},
  meetings: [],
  showMeetingDetails: false,
  meetingData: {
    title: "",
    description: "",
    event: {
      eventId: "",
      eventName: "",
      classCalendarScheduleReferenceId: "",
      classSessionId: ""
    },
    coreGroupId: 0,
    meetingStartTime: "",
    meetingEndTime: "",
    platformId: 0,
    reminder: false,
    createdBy: 0,
    MeetingJoinLink: "",
    coHosts: [],
    timeZoneOffset: 0,
  },
  initialMeetingData: {
    title: "",
    description: "",
    event: {
      eventId: "",
      eventName: "",
      classCalendarScheduleReferenceId: "",
      classSessionId: ""
    },
    coreGroupId: 0,
    meetingStartTime: "",
    meetingEndTime: "",
    platformId: 0,
    reminder: false,
    createdBy: 0,
    meetingLink: "",
    coHosts: [],
    timeZoneOffset: 0,
  },
};

const getters = {
  meetingModalOpen: state => state.meetingModal,
  showMeetingDetails: state => state.showMeetingDetails,
  meetingDisplay: state => state.meetingDisplay,
  getMeetings: state => state.meetings,
  meetingData: state => state.meetingData,
  getMeetingModalType: state => state.meetingModalType,
  getMeetingToEdit: state => state.meetingData,
  addVisitorModal: state => state.visitorModal
};

const actions = {
  fetchMeetings: ({ commit }, personId ) => {
    return new Promise((resolve, reject) => {
      axios.get('/api/meetings/person/' + personId)
        .then(response => {
          console.log('meetings response', response.data)
          commit('setMeetings', response.data)
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getMeetingByID: ({ commit }, meetingId) => {
    return new Promise((resolve, reject) => {
      axios.get('/api/meetings/' + meetingId)
        .then(response => {
          console.log('meeting', response.data);
          commit('setMeetingDisplay', response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // resendEmail: (context, payload) => {
  //   return new Promise((resolve, reject) => {
  //
  //       axios.post(`/api/meetings/resend`,
  //       {
  //           meetingId: payload.meetingId,
  //           member: payload.member,
  //           primaryLeaderMail: payload.primaryLeaderMail,
  //       })
  //         .then(response => {
  //             resolve(response);
  //         })
  //         .catch(error => {
  //             reject(error);
  //         });
  //   });
  // },
  // inviteVisitors: (context, payload) => {
  //   return new Promise((resolve, reject) => {
  //
  //     axios.post(`/api/meetings/invite/visitors`,
  //         {
  //           meetingId: payload.meetingId,
  //           emails: payload.emails,
  //         })
  //         .then(response => {
  //           resolve(response);
  //         })
  //         .catch(error => {
  //           reject(error);
  //         });
  //   });
  // },
};

const mutations = {
  toggleModal: (state) => (state.meetingModal = !state.meetingModal),
  toggleVisitorsModal: (state) => (state.visitorModal = !state.visitorModal),
  setShowMeetingDetails: (state, value) => (state.showMeetingDetails = value),
  setMeetingDisplay: (state, meeting) => { state.meetingDisplay = meeting },
  setMeetings: (state, meetings) => (state.meetings = meetings),
  setMeetingToEdit: (state, meetingData) => (state.meetingData = meetingData),
  setMeetingModalType: (state, modalType) => (state.meetingModalType = modalType),
  addVisitors: (state, values, meetingId) => {
    values.forEach(value => {
      state.meetingDisplay.visitors.push({
        email: value,
        meetingId: meetingId
      })
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
